import React, { useState } from 'react';
import './Rating.css'
import NavDock from '../Components/Layout/NavDock';
import Curve from '../Assets/Icons/Curve.svg'
import RatingImg from '../Assets/Imgs/RatingImg.png'
import StarIcon from '../Assets/Icons/Star.svg';
import { supabase } from '../supabase';
import { useNavigate } from 'react-router-dom';

import Btn from '../Components/Common/Btn';
import StarRating from '../Components/Layout/RatingStars';


const Rating = () => {
    const navigate = useNavigate();
    const [rating, setRating] = useState(0);
    const [message, setMessage] = useState('');

    const isRated = rating > 0;

    const handleFeedbackSubmit = async (e) => {
        e.preventDefault();

        
        if (rating === 0) {
            alert("Please select a star rating before submitting.");
            return;
        }

        const { error } = await supabase
            .from('Feedback')
            .insert([
                { 
                    stars: rating, 
                    message: message 
                }
            ]);

        if (error) {
            console.error("Error saving feedback:", error.message);
            alert("Submission failed: " + error.message);
        } else {
            console.log("Feedback sent!");
            navigate('/home');
        }
    };

    return ( 
        <main className='Rating'>
            <div className='TopBar'></div>
            
            <form className={isRated ? 'MainRatingMsg' : 'MainRating'} onSubmit={handleFeedbackSubmit}>
                
                <img className='RatingImg' src={RatingImg} alt="" />

                <StarRating 
                    icon={StarIcon} 
                    onRate={(val) => setRating(val)} 
                />

                <p className='RatingTitle'>
                    {isRated ? "Thank you!" : "We hope you enjoyed your visit!"}
                </p>
                <p className='RatingSub'>
                    {isRated ? "Anything else you'd like to share?" : "Please rate your experience"}
                </p>

                <div className='Feedback'>
                    <label className='RatingLabel'>Detailed Feedback</label>
                    <textarea 
                        className='RatingMsg' 
                        name="RatingMsg" 
                        placeholder='Tell us about your experience'
                        value={message}
                        onChange={(e) => setMessage(e.target.value)} 
                    ></textarea>
                </div>

                <Btn type='submit' BtnText='Submit' BtnStyle='GreenBtn' />
            </form>

            <NavDock Curve={Curve} NotchClass='NotchCurve'/>
        </main>
    );
}

export default Rating;